export default "/images/vendor/@material-design-icons/svg/filled/thumb_down.svg?52b78567f5ddc8c211930c36f4468e12";